import PortalFormAccess from 'components/molecules/portal_form_access';
import PortalsList from 'components/molecules/portals_list';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getPortals } from 'store/modules/portals_manager_store/actions';
import { PortalsManagerState } from 'store/modules/portals_manager_store/types';
import companyId from 'services/company_id';
import { ProfileState } from 'store/modules/profile_store/types';
import OpenTutorial from 'components/atoms/open_tutorial';

const Portals = () => {
  const dispatch = useDispatch();
  const { request } = useSelector<ApplicationState, PortalsManagerState>(
    (state) => state.session.portals_manager,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    document.title = 'Gerenciar acessos aos portais - ConLicitação';
    dispatch(getPortals(companyId(profile)));
  }, []);

  useEffect(() => {
    dispatch(getPortals(companyId(profile)));
  }, [
    request?.save_portal?.loaded,
    request?.delete_portal?.loaded,
    request?.update_portal?.loaded,
  ]);

  return (
    <div className="page-container p-md-4 pt-3">
      <div className="container-fluid big-resolutions">
        <div className="row">
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center mb-3">
              <h4 className="mb-1 mr-3">Gerenciar acessos aos portais</h4>
              <OpenTutorial type="modal" source="portals" />
            </div>
          </div>
          <div className="col-md-12">
            <div className="card mt-3">
              <div className="card-body">
                <h6 className="mb-3">
                  <strong>Criar novo acesso</strong>
                </h6>
                <PortalFormAccess source="add" />
              </div>
            </div>
            <PortalsList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portals;
